import useMutationCall from "../../../hooks/useMutationCall";
import { useAddOfferMutation } from "../offersSlice";

const useAddOffer = () => {
  return useMutationCall(useAddOfferMutation);
};

export default useAddOffer;